import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { SD_EXPERIMENT_USE_CASES } from '../../../constants/SoftwareDiscoveryConstants';
import { useAccounts } from '../../accounts';
const isExperimentUseCase = useCase => Object.values(SD_EXPERIMENT_USE_CASES).includes(useCase);
const generateLink = (prePath, postPath = '') => `${getFullUrl('app')}/${prePath}/${PortalIdParser.get()}/${postPath}`;
export const useGetToolRecommendations = (useCases = []) => {
  const {
    accounts,
    accountsLoading
  } = useAccounts();
  const userProduct = accounts && accounts.filter(account => account.id === PortalIdParser.get())[0];
  const checkForPaidUser = (enterpriseTier, proTier) => !!(userProduct && (userProduct.products.includes(enterpriseTier) || userProduct.products.includes(proTier)));
  const experimentUseCase = useCases.find(isExperimentUseCase);
  switch (experimentUseCase) {
    case SD_EXPERIMENT_USE_CASES.MARKETING_LEAD_GEN:
      return {
        toolCardNames: ['add-on-ads', 'forms', 'social'],
        toolNames: ['Ads', 'Forms', 'Social Media'],
        toolSlug: ['ads', 'forms', 'social-media'],
        toolLabelTitles: ['learningCenter.toolRecommendations.ads', 'learningCenter.toolRecommendations.forms', 'learningCenter.toolRecommendations.socials'],
        toolCardLinks: [generateLink('ads'), generateLink('forms', 'type'), checkForPaidUser('marketing-enterprise', 'marketing-professional') ? generateLink('social', 'manage') : generateLink('upgrade', 'social-media')],
        shortTitleKey: 'learningCenter.toolRecommendations.marketingLeadGen.shortTitle',
        titleKey: 'learningCenter.toolRecommendations.marketingLeadGen.title',
        descriptionKey: 'learningCenter.toolRecommendations.marketingLeadGen.description',
        experimentUseCase,
        toolLoading: accountsLoading
      };
    case SD_EXPERIMENT_USE_CASES.MARKETING_AUTOMATION:
      return {
        toolCardNames: ['successful-send', 'registration', 'workflows'],
        toolNames: ['Email Marketing Tools', 'Lists', 'Workflows'],
        toolSlug: ['email-marketing-tools', 'lists', 'workflows'],
        toolLabelTitles: ['learningCenter.toolRecommendations.emails', 'learningCenter.toolRecommendations.lists', 'learningCenter.toolRecommendations.workflows'],
        toolCardLinks: [generateLink('email', 'manage/state/all'), generateLink('contacts', 'objectLists/views/all'), checkForPaidUser('marketing-enterprise', 'marketing-professional') ? generateLink('workflows', 'view/default') : generateLink('upgrade', 'workflows')],
        shortTitleKey: 'learningCenter.toolRecommendations.marketingAutomation.shortTitle',
        titleKey: 'learningCenter.toolRecommendations.marketingAutomation.title',
        descriptionKey: 'learningCenter.toolRecommendations.marketingAutomation.description',
        experimentUseCase,
        toolLoading: accountsLoading
      };
    case SD_EXPERIMENT_USE_CASES.SALES_PROSPECTING:
      return {
        toolCardNames: ['calling', 'leads', 'meetings-small'],
        toolNames: ['Calling', 'Leads', 'Meetings'],
        toolSlug: ['calling', 'leads', 'meetings'],
        toolLabelTitles: ['learningCenter.toolRecommendations.calling', 'learningCenter.toolRecommendations.leads', 'learningCenter.toolRecommendations.meetings'],
        toolCardLinks: [checkForPaidUser('sales-enterprise-bundle', 'sales-pro-bundle') ? generateLink('settings', 'user-preferences/calling') : generateLink('pricing', 'upgrade?upgradeSource=calling-free-account-upgrade'), checkForPaidUser('sales-enterprise-bundle', 'sales-pro-bundle') ? generateLink('prospecting', 'leads') : generateLink('pricing', 'upgrade?upgradeSource=prospecting-workspace-leads'), generateLink('meetings')],
        shortTitleKey: 'learningCenter.toolRecommendations.salesProspecting.shortTitle',
        titleKey: 'learningCenter.toolRecommendations.salesProspecting.title',
        descriptionKey: 'learningCenter.toolRecommendations.salesProspecting.description',
        experimentUseCase,
        toolLoading: accountsLoading
      };
    default:
      return undefined;
  }
};